import {
  BorderGreyBox,
  BoxSpg,
  handleSubmitValidationFail,
  SecurityRole,
  SecurityGuard,
  NameFilter,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { SEARCH_FILTERS_GROUP } from "../../../../config/search/filters/groupsConfig";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import { GroupsFilter } from "../../../../types/groupsAndRolesTypes";
import { createGroupsFilterValidationSchema } from "../../../../yup/schema/groupsAndRoles/groupsFilterValidationSchema";
import useSearchTableControl from "../../../../hooks/portal/search/useSearchTableControl";
import { groupsFilterInitialValues } from "../../../../init/groupsAndRolesFiltersInitialValues";
import SearchFilters from "../../common/search/filters/SearchFilters";
import React, { useMemo } from "react";
import GroupsList from "./GroupsList";
import { searchGroups } from "../../../../axios/api/services";
import GroupCreateDialog from "./dialog/GroupCreateDialog";
import { Button, Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { openModal } from "../../../../store/redux/slice/ComponentsControl/groupsControl";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import GroupViewDialog from "./dialog/GroupViewDialog";
import GroupDeleteDialog from "./dialog/GroupDeleteDialog";
import GroupEditDialog from "./dialog/GroupEditDialog";

const GroupFilters = () => {
  return (
    <Grid container spacing={5} px={2} py={6}>
      <NameFilter />
    </Grid>
  );
};

const Groups = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const group = SEARCH_FILTERS_GROUP.GROUPS;

  const filtersData = useAppSelector((state) => {
    return state.SearchData.portalSearchTable[group].filtersData;
  });

  const { methods } = useReactHookForm<GroupsFilter>({
    defaultValues: filtersData,
    validationSchema: createGroupsFilterValidationSchema,
  });

  const control = useSearchTableControl({
    group,
    methods,
    initialValues: groupsFilterInitialValues,
    filterData: searchGroups,
    callAfterResetFilters: true,
  });

  const filterFn = () => {
    control.fetch(false);
  };

  return (
    <>
      <GroupCreateDialog filterFn={filterFn} />
      <GroupViewDialog />
      <GroupEditDialog filterFn={filterFn} />
      <GroupDeleteDialog filterFn={filterFn} />
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(
            () => control.handleSubmitFilters(),
            () => handleSubmitValidationFail(methods.formState, t, undefined),
          )}
        >
          <BoxSpg mt={2}>
            <BorderGreyBox>
              <SearchFilters
                isSubmitBtnDisabled={control.isSubmitBtnDisabled}
                isResetBtnDisabled={control.isResetBtnDisabled}
                handleResetFilters={control.handleResetFilters}
              >
                {useMemo(
                  () => (
                    <GroupFilters />
                  ),
                  [],
                )}
              </SearchFilters>
            </BorderGreyBox>
            {control.showList && (
              <GroupsList
                records={control.records}
                total={control.total}
                isLoading={control.isLoading}
                onPageOrOrderChange={control.handlePageOrOrderChange}
                blockTable={control.blockTable}
                group={group}
              />
            )}
          </BoxSpg>
        </form>
      </FormProvider>
      <SecurityGuard checkForRoles={[SecurityRole.AcGroupsCreate]}>
        <Button
          startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faAdd} />}
          size={"medium"}
          type={"button"}
          variant="contained"
          color="secondary"
          onClick={() => dispatch(openModal({ id: null, modalType: "create" }))}
        >
          {t("l.btn.create.group")}
        </Button>
      </SecurityGuard>
    </>
  );
};

export default Groups;
